import React, { useState, useEffect, useRef } from 'react';

const Testimonials = () => {
  const [slideIndex, setSlideIndex] = useState(1);
  const slidesRef = useRef([]);

  const testimonials = [
    {
      quote: "“After getting connected with Ethiccraft Club, I feel that my outlook towards life has completely changed. My thoughts have gained clarity and wisdom. I am very thankful to the club for shaping my life.”",
      image: "/assets/Testimonials/Lokesh_Kaushik.jpg",
      name: "Lokesh Kaushik",
      position: "Software Engineer, Samsung R&D Institute, Noida",
    },
    {
      quote: "“I got connected with Ethiccraft Club during my third year of Engineering. Earlier, I would not interact with people much but after getting connected with the club, I started interacting with many people and learnt the art of situation tackling..”",
      image: "/assets/Testimonials/Pankaj_Narayan.jpg",
      name: "Pankaj Panghal",
      position: "Software Engineer, Samsung R&D Institute, Noida",
    },
    {
      quote: "“While pursuing my studies, I was trying to know the various secrets associated with a happy and satisfied life. I got answers to all my queries after getting a meeting with the members of Ethiccraft Club. Ethiccraft Rocks!!”",
      image: "/assets/Testimonials/Aman_Jindal.jpg",
      name: "Aman Jindal",
      position: "Hardware Design Engineer, Marelli India Pvt Ltd",
    },
  ];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const interval = setInterval(() => {
      showSlides(slideIndex + 1);
    }, 8000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slideIndex]);


  useEffect(() => {
    showSlides(slideIndex);

    const handleKeydown = (e) => {
      if (e.key === "ArrowLeft") {
        plusSlides(-1);
      } else if (e.key === "ArrowRight") {
        plusSlides(1);
      }
    };
    window.addEventListener('keydown', handleKeydown);

    return () => window.removeEventListener('keydown', handleKeydown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slideIndex]);

  const showSlides = (n) => {
    let newIndex = n;
    if (n > testimonials.length) {
      newIndex = 1;
    }
    if (n < 1) {
      newIndex = testimonials.length;
    }
    setSlideIndex(newIndex);
  };

  const plusSlides = (n) => {
    showSlides(slideIndex + n);
  };

  const currentSlide = (n) => {
    showSlides(n);
  };

  return (
    <section className="testimonials-section">
      <div className="slideshow-container">
        <div className="testimonial-header">
          <h2 className="T-heading">TESTI<span style={{ color: '#555' }}>MONIALS</span></h2>
        </div>

        <div className="quote-icon">“</div>

        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            className={`mySlides fade ${slideIndex === index + 1 ? 'active' : ''}`}
            ref={(el) => (slidesRef.current[index] = el)}
          >
            <p className="quote">{testimonial.quote}</p>
            <div className="testimonial-info">
              <p className="testimonial-name">{testimonial.name}</p>
              <p className="testimonial-position">{testimonial.position}</p>
            </div>
          </div>
        ))}

      </div>

      <div className="testimonial-nav">
        {testimonials.map((testimonial, index) => (
          <img
            key={index}
            src={testimonial.image}
            className={`nav-img ${slideIndex === index + 1 ? 'active' : ''}`}
            onClick={() => currentSlide(index + 1)}
            alt={`Testimonial from ${testimonial.name}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Testimonials;